import { IBaseAction, PaginationQuery } from '../../constants';
import { Moment } from 'moment-jalaali';

export interface weekDates {
    startOfWeekDate: Moment;
    endOfWeekDate: Moment;
}

export const activeType = 'active';
export const WeekDayFormat = 'ddd jMM/jDD';

export const calendarColors = {
    requestColor: '3,155,229',
    //flightsColor: '#33B679',
    flightsColor: '51,182,121',
    futureItemsOpacity: 0.6,
    cancelledFlightsColor: '213,0,0',
};

export interface FlightDetails {
    type: string;
    airline: string;
    incoming: boolean;
    source: string;
    destinations: string[];
    flightNumber: string;
    register: string;
    airplaneType: string;
    nightStay: boolean;
    startDate: Date;
    endDate: Date;
    rangeStartDate?: Date;
    rangeEndDate?: Date;
    baseStartDate?: Date;
    baseEndDate?: Date;
    baseDepartureTime?: Date;
    baseEntranceTime?: Date;
    entranceTime: Date;
    departureTime: Date;
    requestNumber: string;
    endEventTime?: Date;
    startEventTime?: Date;
    isRequest?: boolean;
}

export interface Flight {
    type: string;
    airline: string;
    incoming: boolean;
    source: string;
    destinations: string[];
    flightNumber: string;
    register: string;
    airplaneType: string;
    nightStay: boolean;
    startDate: Date;
    endDate: Date;
    rangeStartDate?: Date;
    rangeEndDate?: Date;
    baseStartDate?: Date;
    baseEndDate?: Date;
    baseDepartureTime?: Date;
    baseEntranceTime?: Date;
    entranceTime: Date;
    departureTime: Date;
    requestNumber: string;
    endEventTime?: Date;
    startEventTime?: Date;
    isRequest?: boolean;
    status: string;
}

export interface FlightListState {
    data: Flight[];
    total: 0;
}

export interface FlightsListInitialState {
    flights: Array<Flight>;
}
export const FLIGHT_LIST = 'FLIGHT_LIST';
export const FLIGHT_LIST_SUCCESS = 'FLIGHT_LIST_SUCCESS';
interface GetFlightsList extends IBaseAction {
    type: typeof FLIGHT_LIST | typeof FLIGHT_LIST_SUCCESS;
    payload: {
        data: FlightsListInitialState;
    };
}

export class GetFlightsListQuery extends PaginationQuery {
    // terminalId: number | null = null;
    // queueId: number | null = null;
    // announceDateTo: Date | null = null;
    // announceDateFrom: Date | null = null;
    // dateFrom: Date | null = null;
    // dateTo: Date | null = null;
    // repetitionNum: number | null = null;
    // flightNumber: string | null = null;

    constructor() {
        super();
    }
}

export type FlightsActionTypes = GetFlightsList;
